import {
  type ForwardRefRenderFunction,
  type ReactNode,
  forwardRef,
} from 'react';
import { Group, type GroupProps } from 'react-aria-components';
import type { OmittedReactAriaProps } from '../types';
import { type DisplayVariants, base } from './Flex.css';

type Props = Omit<GroupProps, OmittedReactAriaProps> &
  DisplayVariants & {
    children: ReactNode;
    style?: Record<string, string | number>;
  };

const BaseFlex: ForwardRefRenderFunction<HTMLDivElement, Props> = (
  {
    children,
    flexDirection = 'row',
    gap,
    rowGap,
    columnGap,
    flexWrap = 'nowrap',
    padding,
    paddingBottom,
    justifyContent,
    ...props
  },
  ref,
) => {
  return (
    <Group
      {...props}
      ref={ref}
      className={base({
        flexDirection,
        gap,
        rowGap,
        columnGap,
        flexWrap,
        padding,
        paddingBottom,
        justifyContent,
      })}
    >
      {children}
    </Group>
  );
};

export const Flex = forwardRef(BaseFlex);
